import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Check, Compass } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian text-cream flex flex-col items-center justify-center p-5" data-testid="forgot-password-page">
      <Link to="/admin/login" className="flex items-center gap-2.5 mb-10" data-testid="forgot-logo">
        <Compass className="h-6 w-6 text-copper" />
        <span className="font-serif text-xl tracking-[0.18em] uppercase">De Los Cielos</span>
      </Link>
      <div className="w-full max-w-sm card-dark p-8">
        {sent ? (
          <div data-testid="forgot-success">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-copper text-copper mb-5"><Check className="h-5 w-5" /></span>
            <h1 className="font-serif text-2xl">Email inviata.</h1>
            <p className="mt-3 text-sm text-cream2 leading-relaxed">Se l'indirizzo è registrato, ricevi a breve un link per scegliere una nuova password. Controlla anche la cartella spam: il link resta valido un'ora.</p>
            <Link to="/admin/login" className="btn-copper w-full mt-7" data-testid="forgot-back-login">Torna all'accesso</Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <h1 className="font-serif text-2xl">Recupera l'accesso</h1>
            <p className="mt-2 text-sm text-cream2 leading-relaxed">Scrivi l'email del tuo account: ti mandiamo un link per scegliere una nuova password.</p>
            <div className="mt-6">
              <label className="label" htmlFor="f-email">Email</label>
              <input id="f-email" type="email" required className="field" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
            </div>
            {error && <p className="mt-4 text-sm text-red-400" data-testid="forgot-error">{error}</p>}
            <button type="submit" disabled={busy} className="btn-copper w-full mt-6 disabled:opacity-50" data-testid="forgot-submit-btn">
              {busy ? "Invio…" : "Invia il link"}
            </button>
          </form>
        )}
      </div>
              <Link to="/admin/login" className="mt-8 font-mono text-[10px] uppercase tracking-widest text-sand hover:text-copperlight transition-colors flex items-center gap-2" data-testid="forgot-back-link">
        <ArrowLeft className="h-3.5 w-3.5" /> Torna all'accesso
      </Link>
    </div>
  );
}
